import React from 'react';

import PropTypes from 'prop-types';
import { Table, Checkbox, Icon } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import { QuestionType } from 'components/modules/questions/types';

import QuestionTableRow from './components/QuestionTableRow';

import './QuestionsTable.scss';

const propTypes = {
  questions: PropTypes.arrayOf(QuestionType).isRequired,
  selectedQuestionIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onQuestionSelect: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onEditQuestion: PropTypes.func.isRequired,
  onDeleteQuestion: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function QuestionsTable({
  questions,
  selectedQuestionIds,
  onQuestionSelect,
  onSelectAll: onSelectAllProp,
  onEditQuestion,
  onDeleteQuestion,
}) {
  function onSelectAllChange(e, { checked }) {
    onSelectAllProp(checked);
  }

  const allSelected = questions.length > 0 && selectedQuestionIds.length === questions.length;
  const someSelected =
    selectedQuestionIds.length > 0 && selectedQuestionIds.length < questions.length;

  if (_isEmpty(questions)) {
    return (
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan="6" textAlign="center">
              <div className="empty-state">
                <Icon name="question circle" size="huge" />
                <h3>No questions found</h3>
                <p>Create your first question to get started</p>
              </div>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
      </Table>
    );
  }

  return (
    <div className="questions-table">
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell collapsing>
              <Checkbox
                checked={allSelected}
                indeterminate={someSelected}
                onChange={onSelectAllChange}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>Question</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Answered</Table.HeaderCell>
            <Table.HeaderCell>Groups</Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {questions.map((question) => (
            <QuestionTableRow
              key={question.id}
              question={question}
              isSelected={selectedQuestionIds.includes(question.id)}
              onSelect={onQuestionSelect}
              onEdit={onEditQuestion}
              onDelete={onDeleteQuestion}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
}

QuestionsTable.propTypes = propTypes;
QuestionsTable.defaultProps = defaultProps;
